<div class="main-content">
  <div class="card p-4">
    <div class="d-flex justify-content-between">
      <div class="col-md-8">
        <div class="left-side">
          <div class="card left-side">
            <div class="card-body">
              <div class="map"
                   leaflet
                   [leafletFitBounds]="bounds"
                   [leafletOptions]="options"
                   leafletDraw
                   [leafletDrawOptions]="drawOptions"
                   (leafletMapReady)="mapReady($event)"
                   (leafletDrawCreated)="onDrawCreated($event)"
              >
                <div [leafletLayer]="drawnItems"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="right-side">
          <div class="card right-side">
            <div class="card-body">
              <h5 class="card-title mx-3">Geofence</h5>
              <hr>

              <div class="card-body">
                <div class="row align-items-end">
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="form-group">
                        <label class="mt-2" for="name">Name <span aria-hidden="true" placement="right-top" class="fa fa-info-circle"></span></label>
                        <div class="input-parent">
                          <div>
                            <input class="form-control" id="name" type="text" placeholder="Required" [(ngModel)]="geofence.name" required>
                            <span *ngIf="!geofence.name || errors.geofenceName" class="text-danger" [(ngModel)]="errors.geofenceName">Required</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row align-items-end">
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="form-group">
                        <label class="mt-2" for="name">Description <span aria-hidden="true" placement="right-top" class="fa fa-info-circle"></span></label>
                        <div class="input-parent">
                          <div>
                            <input class="form-control" id="description" type="text" placeholder="Required" [(ngModel)]="geofence.description" required>
                            <span *ngIf="!geofence.description || errors.geofenceDescription" class="text-danger" [(ngModel)]="errors.geofenceDescription">Required</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row align-items-end">
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="form-group">
                        <label class="mt-2" for="name">Geofences (select to navigate) <span aria-hidden="true" placement="right-top" class="fa fa-info-circle"></span></label>
                        <div class="input-parent">
                          <div>
                            <select class="form-control custom-border-styling"
                                    name="geofenceSelect"
                                    (ngModelChange)="onChangeGeofence($event)"
                                    [(ngModel)]="selectedGeofence"
                                    id="selectGeofence">
                              <option *ngFor="let c of otherGeofences" [ngValue]="c">{{c.name}}</option>

                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <button class="btn btn-primary" (click)="saveGeofence()">Save Geofence</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="col-md-4">
        <label class="mt-2" for="duration">Add alert trigger (mins)</label>
        <input class="form-control" id="duration" type="number" placeholder="Required" [(ngModel)]="duration">
        <button   class="btn btn-primary" (click)="addNewAlert() ">Add Alert</button>
      </div>
    </div>

    <div *ngIf="geofenceAlerts.length" class="table-sm">
      <table class="table table-striped" aria-describedby="View Alerts">
        <thead>
        <tr>
          <th scope="col">Time(minutes)</th>
          <th scope="col">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr  *ngFor="let item of geofenceAlerts">
          <td class="w-50">
            <div class="col-md-4">
              <span>{{item.duration}}</span>
            </div>
          </td>
          <td>
            <div>
              <button class="btn btn-primary mx-2" (click)="openUserModal(item)">Manage Users</button>
              <button (click)="removeAlert(item)" class="btn btn-danger mx-2">
                Delete
              </button>
            </div>

          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
